import CryptoJS from 'crypto-js'

const keyStr = 'OD8DfkNu5SfCLd4F';
export default {
	encrypt(data) {
		// var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), keyStr).toString();
		let key = CryptoJS.enc.Utf8.parse(keyStr);
		let srcs = JSON.stringify(data);
		let encrypted = CryptoJS.AES.encrypt(srcs, key, { 
			mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7
		});
		let hexStr = encrypted.ciphertext.toString();
		return hexStr;
	},
	
	decrypt(data) {
		let key = CryptoJS.enc.Utf8.parse(keyStr);
		let hexStr = CryptoJS.enc.Hex.parse(data);
		let base64Str = CryptoJS.enc.Base64.stringify(hexStr);
		let decrypt = CryptoJS.AES.decrypt(base64Str, key, {
			mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7
		});
		let deStr = decrypt.toString(CryptoJS.enc.Utf8);
		return JSON.parse(deStr);
	}
}


// WEBPACK FOOTER //
// ./src/units/aes.js